import 'css-chunksrc/client/pages/projectPage/kanbanPage/toolbar/styles.scss';export default {
  "filters": "_filters_17zpq_1"
};